/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RegionManager } from '@scenario/models/region-manager.model';
import { RootState } from '@store/create-store';
import {
  createRegionManager,
  retrieveRegionManagers,
  saveRegionManagerFailure,
  saveRegionManagerSuccess,
} from '@store/scenario/region-manager/region-manager-slice';

export const createRegionManagerEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType(createRegionManager.type),
  concatMap((action: PayloadAction<RegionManager>) =>
    from(dependencies.regionManagerGateway.create(action.payload)).pipe(
      concatMap(() => of(retrieveRegionManagers(), saveRegionManagerSuccess())),
      catchError((error: Error) => of(saveRegionManagerFailure(error.message || 'Failed to create region manager'))),
    )),
);
